(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('statusDropdown', {
            templateUrl: 'app/components/status-dropdown/status-dropdown.html',
            controller: statusDropdownController,
            bindings: {
                name: '@',
                options: '<',
                onChange: '&',
                value: '=',
            }
        })
        .directive("changeStatus", function () {
            return {
                restrict: "A",
                link: function (scope) {
                    scope.$watch("$ctrl.value", function (newValue) {
                        if (scope.$ctrl.onChange) {
                            scope.$ctrl.onChange({ newValue: newValue });
                        }
                    });
                },
            };
        });

    /** @ngInject */
    function statusDropdownController($translate) {
        var $ctrl = this;
        var THRESHOLD_VALUE = 15;

        $ctrl.$onInit = function () {
            $ctrl.selectOption($ctrl.value);
        };

        $ctrl.selectOption = function (option) {
            $ctrl.selectedOption = option;
            getButtonLabel();
            $ctrl.onChange({ newValue: $ctrl.selectedOption });
        };

        function getButtonLabel() {
            if ($ctrl.selectedOption && $ctrl.selectedOption.title) {
                $ctrl.buttonLabel =
                    $translate.instant('salesFunnel.label.status') +
                    ' | ' + truncateText($ctrl.selectedOption.title, THRESHOLD_VALUE);
            } else {
                $ctrl.buttonLabel = $translate.instant('salesFunnel.label.status');
            }
        }
    }
})();
